import { AlertService } from '../../Services/alert.service';
import { GroupService } from '../../Services/group.service';
import { MemberService } from '../../Services/member.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';
import { DiscountService } from '../../Services/discount.service';
import { ModuleService } from '../../Services/modules.service';
import { Response } from '@angular/http';
import { saveAs } from 'file-saver';
import { AuthService } from '../../Services/auth.service';
import { GeneralSettingsService } from '../../Services/general-settings.service';
@Component({
  selector: 'app-member-form',
  template: require('./member-form.component.html'),
  styles: [require('./member-form.component.css')]
})
export class MemberFormComponent implements OnInit {
  groups: any[] = [];
  discounts: any[] = [];
  member: any = {
    groupId:1,
    memberDiscountID:1
  };

  totalAmountClothes:number=0;
  totalAmountHolidays:number=0;

  clothesDiscountUsed:number=0;
  holidayDiscountUsed:number=0;

  showHealthInsurance:boolean = false;
  healthInsurancePaperCheck:boolean = false;

  enabledModules: any = [];
  selectedDate: any;
  selectedStartDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };


  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private memberService: MemberService,
    private groupService: GroupService,
    private toastyService: ToastyService,
    private alertService: AlertService,
    private discountService: DiscountService,
    private module: ModuleService,
    private generalSettingsService: GeneralSettingsService,
    private auth: AuthService
  ) {

    route.params.subscribe(p => {
      if (p['id'])
        this.member.id = +p['id'];
      else
        this.member.id = 0;
    });

  }

  ngOnInit() {
    if (this.member.id > 0) {
      this.memberService.getMember(this.member.id).subscribe(m => {
        // console.log(m);
        
        this.member = m

        this.totalAmountClothes = this.member.memberDiscount.amountClothes;
        this.totalAmountHolidays = this.member.memberDiscount.amountHolidays;

        // console.log("ngOnInit of memberform")
        var bd = new Date(this.member.birthday)
        this.selectedDate = {
          jsdate: bd,
          date:{year: bd.getFullYear(), month: bd.getMonth() +1, day: bd.getDate()}
        };  
        var ms = new Date(this.member.memberSince)
        if (ms.getFullYear() == 1){
          this.selectedStartDate = {
            jsdate: ms,
            date:{year: 1900, month: ms.getMonth() +1, day: ms.getDate()}
          };
        }else{
          this.selectedStartDate = {
            jsdate: ms,
            date:{year: ms.getFullYear(), month: ms.getMonth() +1, day: ms.getDate()}
          };  
        }
        // console.log(m);
      }, err => {
        if (err.status == 404) {
          // this.router.navigate(['/home']);
          console.log(err);
          console.log(this.member.id);
        }
        if (err.status == 403) {
          this.router.navigate(['/home']);
          //   console.log("No access!!!");
        }
      });

      this.memberService.getDiscountUsedForMember(this.member.id).subscribe( (res:any)=>{
        if (res.status == 200){
          this.clothesDiscountUsed = res.value.amountClothesused;
          this.holidayDiscountUsed = res.value.amountHolidayUsed;
        }
      }) 

    }

    this.groupService.getGroupNames(false).subscribe(g => {
      this.groups = g
      // console.log("groups: " + this.groups);
    //  console.log(this.member)
    });

    this.discountService.getDiscounts().subscribe( d => {
      this.discounts = d
      // console.log("Discounts: " +JSON.stringify(this.discounts));
    })

    this.module.getAllModules().subscribe( (x:any)=>{
      this.enabledModules = x;
      this.isHealthInsuranceAvailable()
    })

  }

  submit() {
    if (this.member.id) {
      if (this.selectedDate){
        this.member.birthday = String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day);
      }
      if (this.selectedStartDate){
        this.member.memberSince = String(this.selectedStartDate.date.year)+"-"+String(this.selectedStartDate.date.month)+"-"+String(this.selectedStartDate.date.day);
      }
      // console.log(this.member);
      var data =[
        {key:"clothes", value:this.clothesDiscountUsed},
        {key:"holidays", value:this.holidayDiscountUsed}
      ]
        
      
      this.memberService.setDiscountsUsedForMember(this.member.id, data).subscribe ( (res:any)=>{
        
      })
      this.memberService.update(this.member).subscribe(x => {
        this.alertService.success("Opgeslagen", true);
        this.router.navigate(['/members/list']);
      });
    }
    else {
      this.memberService.create(this.member).subscribe(x => {
        // console.log(x));
      })
      this.router.navigate(['/members/list']);
    }

  }

  delete() {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit lid wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.memberService.delete(this.member.id).subscribe(x => {
            this.router.navigate(['/members/list']);
          });
        }
      });
  }

  showDiscountInformation(){

    var innerHtml:string = `<table style='padding: 0; border-spacing: 0; border-collapse: collapse;'>
    <thead>
      <th style='border: 1px solid; padding: 0.5em; background-color: #abb0ac;'>code</th>
      <th style='border: 1px solid; padding: 0.5em; background-color: #abb0ac;'>omschrijving</th>
      <th style='border: 1px solid; padding: 0.5em; background-color: #abb0ac;'>korting lidgeld</th>
      <th style='border: 1px solid; padding: 0.5em; background-color: #abb0ac;'>budget kledij</th>
      <th style='border: 1px solid; padding: 0.5em; background-color: #abb0ac;'>budget vakanties</th>
    </thead>
    `
    this.discounts.forEach(d => {
      innerHtml += `<tr>
                  <td style='border: 1px solid; padding: 0.5em; background-color: #abb0ac;'> ${d.code}</td>
                  <td style='border: 1px solid; padding: 0.5em;'>${d.description}</td>
                  <td style='border: 1px solid; padding: 0.5em;'>${d.amountMembership} &euro;</td>
                  <td style='border: 1px solid; padding: 0.5em;'>${d.amountClothes} &euro;</td>
                  <td style='border: 1px solid; padding: 0.5em;'>${d.amountHolidays} &euro;</td>
                </tr>
            `
    })
    innerHtml += '</table>' 
    
    Swal.fire({
      title: "<Strong>Categorie informatie</strong>",
      // type: 'info',
      // html: '<div style="text-align:left"> '+ 
      //       '<ul> '+
      //       '<li> code 1:&nbsp;&nbsp;0 - 15 ritten en nieuwe leden</li>'+
      //       '<li> code 2:&nbsp;16 - 20 ritten</li>'+
      //       '<li> code 3:&nbsp;21 - 25 ritten</li>'+
      //       '<li> code 4:&nbsp;+25 ritten</li>'+
      //       '</ul></div> ',
      html: innerHtml,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Okay',
    });
  }

  uploadFoto() {
    if (this.member.id > -1) {
      var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
      if (nativeElement != null) {
        var files = nativeElement.files;
        if (files != null) {
          var file = files[0];
          // console.log("Upload file: ")
          // console.log(file.name);
          // console.log(this.member)
          this.memberService.uploadFile(this.member.id, file).subscribe(x => {
            this.member = x;
          })
        }
      }
    }

  }

  DiscountCodeChanged(value:number){
    if (value > 1){
      this.member.isExemptFromPayment = true;
    }else{
      this.member.isExemptFromPayment = false;
    }
   } 

   hasPayedMemberShipChanged(){
    if (this.member.hasPayedMemberShip){
      var d = new Date()
      var payedDate = d.toISOString().substring(0,10)+"T00:00:00"
      this.member.payedDate = payedDate;
    }else{
      this.member.payedDate = "1970-01-01T00:00:00";
    }
   }

  checkIfEnabled(s: string){
    for (var i = 0; i < this.enabledModules.length; i++){
        if (this.enabledModules[i].moduleName == s) {
            return this.enabledModules[i].enabled
        }
    }
    return false;
  }

  isHealthInsurancePaperVisible(){
    if (this.healthInsurancePaperCheck){
        if (this.checkIfEnabled('healtinsurancePaper') && this.member.hasPayedMemberShip){
            this.showHealthInsurance = true;
        }
        else {
            this.showHealthInsurance = false;
        }
    }else{
        this.showHealthInsurance = false;
    }
  }

  private isHealthInsuranceAvailable(){
    this.generalSettingsService.getHealthInsurancePaperCheck().subscribe( (res:any)=>{
        if (res.status == 200){
            this.healthInsurancePaperCheck = JSON.parse(res.value.healthInsurancePapersAvailable.toLowerCase()); 
            this.isHealthInsurancePaperVisible();
        }
    })
  }

  private downloadMemberHealthInsurancePaper(id:number){
    this.memberService.downloadHealthInsurancePaper(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  private downloadMemberCard(id: number){
    this.memberService.downloadMembercard(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          saveAs(res.blob(), filename);
        }
      }
    });
  }


  private downloadHealthInsuranceDoc(id: number){
    this.memberService.downloadHealthInsurancePaper(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  private sendMemberSubscriptionPaymentEmail(id: number){
    Swal.fire({
      title: 'Ben je zeker?',
      html: "Ben je zeker dat je de betalings email wil versturen",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.memberService.sendMemberSubscriptionPaymentEmail(id).subscribe( (res:any)=>{
          if (res.status == 200){
            Swal.fire({
              title: 'E-mail verstuurd',
              text: "Er is "+res.value.emailsSend+" email verstuurd.",
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Ok',
            })
          }
        })
       
      }
    });       
  }

}
  




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-form/member-form.component.ts